import { useLocation as useRouterLocation } from 'react-router-dom';
export const useLocation = () => {
    const location = useRouterLocation();
    return location;
};
